import { Auth } from "aws-amplify";
import { clearData } from "../pages/account/profileSlice";
import { logout } from "../pages/auth/registrationSlice";

const checkUser = async () => {
    try {
        const user = await Auth.currentAuthenticatedUser();
        if(!user){
            sessionStorage.removeItem('selectedSellerEmail');
            localStorage.clear();
            Auth.signOut();
            window.location.href = "/login";
        }
    } catch (err) {
        console.log(err, 'error...');
        sessionStorage.removeItem('selectedSellerEmail');
        localStorage.clear();
        Auth.signOut();
        window.location.href = "/login";
    }
};


/**
 * The function `authHeader` returns an object containing an Authorization header with a JWT token.
 * @returns an object containing the Authorization header with the JWT token.
 */
export async function authHeader() {
// Call checkUser in a try-catch block, but skip on login page to avoid race condition
// during login where Auth.currentAuthenticatedUser() throws before session is committed
    if (window.location.pathname !== '/login') {
        checkUser()
    }

    const idToken = await Auth.currentSession()
    const headers = {
        Authorization: `Bearer ${idToken.getIdToken().getJwtToken()}`,
    }
    return headers;
}


export const isSuperAdminSession = () =>
    Boolean(sessionStorage.getItem('selectedSellerEmail'));